import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getAnomaly } from "./dbTableApi";

export const tableSlice = createSlice({
    name: 'table',
    initialState: {
        data: [],
        editor: null
    },
    reducers: {

        reset: (state) => {
            state.data = []
        },
        resetEditor: (state) => {
            console.log('RESET EDITOR')
            state.editor = null
        },
        setEditor: (state, action) => {
            state.editor = state.data[action.payload]
        },
        cleanEditor: (state) => {
            state.editor = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAnomaly.fulfilled, (state, action) => {

            state.data = action.payload



            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(getAnomaly.pending, (state, action) => {
        })

        builder.addCase(getAnomaly.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });

        })




    }
})


export const { reset, setEditor, resetEditor } = tableSlice.actions

export default tableSlice.reducer
